export default <T>() =>
  (name: keyof T) =>
    name;
